import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ProfileStore } from 'app/state-management/profile/profile.store';

/**
 * Guard for the restricted `/licenses` route that is only accessible when `hasAnyLicense` is false.
 * If the user already has a valid license, redirect them to `/administration/licenses` instead.
 * Only active on dev environment.
 */
export const noLicenseRequiredGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const profileStore = inject(ProfileStore);
  const router: Router = inject(Router);

  return profileStore.hasAnyLicenseOrNull$.pipe(
    take(1),
    map((hasAnyLicense: boolean) => !hasAnyLicense || router.createUrlTree(['/administration', 'licenses']))
  );
};
